// Generated from SVG to React Component
import React, { SVGProps } from "react";

export const PercentMd = ({ color = "black", ...props }: SVGProps<SVGSVGElement>) => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path d="M15.8332 4.16675L4.1665 15.8334M7.49984 5.83341C7.49984 6.75389 6.75365 7.50008 5.83317 7.50008C4.9127 7.50008 4.1665 6.75389 4.1665 5.83341C4.1665 4.91294 4.9127 4.16675 5.83317 4.16675C6.75365 4.16675 7.49984 4.91294 7.49984 5.83341ZM15.8332 14.1667C15.8332 15.0872 15.087 15.8334 14.1665 15.8334C13.246 15.8334 12.4998 15.0872 12.4998 14.1667C12.4998 13.2463 13.246 12.5001 14.1665 12.5001C15.087 12.5001 15.8332 13.2463 15.8332 14.1667Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>

);
